class popup extends HTMLElement {
    constructor() {
        super();
        const popupContainer = this;

        if (!popupContainer) {
            return;
        }

        if (popupContainer.classList.contains('js-popup-design-ignore')) {
            const popupCloseButton = popupContainer?.querySelector('.js-popup-close');

            // Close the popup when the close button is clicked
            if (popupCloseButton) {
                popupCloseButton.addEventListener('click', function () {
                    popupContainer.classList.remove('js-open');
                });
            }

            // Close when clicking outside the popup
            document.querySelector('.popup__overlay').addEventListener('click', () => {
                const isOpen = popupContainer.classList.contains('js-open');
                if (isOpen) {
                    popupContainer.classList.remove('js-open');
                }
            });

            return;
        }

        const popupCloseButton = popupContainer?.querySelector('.js-popup-close');
        const popupContaineruid = popupContainer?.dataset.sectionId;
        const displayFrequency = popupContainer?.dataset.frequency; // Get the display frequency from the data attribute

        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

        if (popupContainer) {
            if (displayFrequency === 'every_session') {
                // Always open the popup in every session
                if (!sessionStorage.getItem(`${popupContaineruid}-popupShown`)) {
                    popupContainer.classList.add('js-open');
                    sessionStorage.setItem(`${popupContaineruid}-popupShown`, 'true');
                }
            } else if (displayFrequency === 'daily') {
                // Open the popup only once per day
                const lastShownDate = localStorage.getItem(`${popupContaineruid}-popupLastShownDate`);
                if (lastShownDate !== today) {
                    popupContainer.classList.add('js-open');
                    localStorage.setItem(`${popupContaineruid}-popupLastShownDate`, today);
                }
            } else if (displayFrequency === 'until_close') {
                // Open the popup if it hasn't been closed yet
                if (localStorage.getItem(`${popupContaineruid}-popupShown`) !== 'true') {
                    popupContainer.classList.add('js-open');
                }
            }
        }

        // Close the popup when the close button is clicked
        if (popupCloseButton) {
            popupCloseButton.addEventListener('click', function () {
                popupContainer.classList.remove('js-open');
                if (displayFrequency === 'until_close') {
                    localStorage.setItem(`${popupContaineruid}-popupShown`, 'true');
                }
            });
        }

        // Close when clicking outside the popup
        document.querySelector('.popup__overlay').addEventListener('click', () => {
            const isOpen = popupContainer.classList.contains('js-open');
            if (isOpen) {
                popupContainer.classList.remove('js-open');
                if (displayFrequency === 'until_close') {
                    localStorage.setItem(`${popupContaineruid}-popupShown`, 'true');
                }
            }
        });
    }
}

customElements.define('pop-up', popup);
